var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition-group", { attrs: { name: "slide-fade", tag: "div" } }, [
        _vm.isDiarioVisible()
          ? _c(
              "a",
              {
                key: "periodoDias",
                staticClass: "btn",
                class: _vm.getClass("saldoDiario"),
                attrs: { href: "javascript:;" },
                on: {
                  click: function ($event) {
                    return _vm.setCamposVisual("saldoDiario")
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-calendar" }),
                _vm._v(" Dias\n        "),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a",
          {
            key: "periodoMeses",
            staticClass: "btn",
            class: _vm.getClass("periodoMeses"),
            attrs: { href: "javascript:;" },
            on: {
              click: function ($event) {
                return _vm.setCamposVisual("periodoMeses")
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-calendar" }),
            _vm._v(" Meses\n        "),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            key: "visuaperiodoTrimestreslTwo",
            staticClass: "btn",
            class: _vm.getClass("periodoTrimestres"),
            staticStyle: { "margin-left": "3px" },
            attrs: { href: "javascript:;" },
            on: {
              click: function ($event) {
                return _vm.setCamposVisual("periodoTrimestres")
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-calendar" }),
            _vm._v(" Trimestres\n        "),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            key: "periodoSemestres",
            staticClass: "btn",
            class: _vm.getClass("periodoSemestres"),
            staticStyle: { "margin-left": "3px" },
            attrs: { href: "javascript:;" },
            on: {
              click: function ($event) {
                return _vm.setCamposVisual("periodoSemestres")
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-calendar" }),
            _vm._v(" Semestres\n        "),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            key: "periodoAnos",
            staticClass: "btn",
            class: _vm.getClass("periodoAnos"),
            staticStyle: { "margin-left": "3px" },
            attrs: { href: "javascript:;" },
            on: {
              click: function ($event) {
                return _vm.setCamposVisual("periodoAnos")
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-calendar" }),
            _vm._v(" Anos\n        "),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("transition-group", { attrs: { name: "slide-fade", tag: "div" } }, [
        _c(
          "a",
          {
            key: "visualOne",
            staticClass: "btn",
            class: _vm.getClass("saldoAnteriorAtual"),
            attrs: { href: "javascript:;" },
            on: {
              click: function ($event) {
                return _vm.setCamposVisual("saldoAnteriorAtual")
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-money" }),
            _vm._v(" Saldo anterior e saldo atual\n        "),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            key: "visualTwo",
            staticClass: "btn",
            class: _vm.getClass("debitosCreditos"),
            staticStyle: { "margin-left": "3px" },
            attrs: { href: "javascript:;" },
            on: {
              click: function ($event) {
                return _vm.setCamposVisual("debitosCreditos")
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-money" }),
            _vm._v(" Débitos e créditos\n        "),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            key: "visualThree",
            staticClass: "btn",
            class: _vm.getClass("saldoMes"),
            staticStyle: { "margin-left": "3px" },
            attrs: { href: "javascript:;" },
            on: {
              click: function ($event) {
                return _vm.setCamposVisual("saldoMes")
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-money" }),
            _vm._v(" Saldo do mês\n        "),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("transition-group", { attrs: { name: "slide-fade" } }, [
        _c(
          "div",
          { key: "tipoSubFilter" },
          [
            _c("contabil-balancete-filtro-tipo", {
              attrs: {
                button: "primary",
                colorSelected: _vm.colorSelected,
                colorDeselected: _vm.colorDeselected,
                defaultPosteriorDate: _vm.defaultPosteriorDate,
              },
            }),
            _vm._v(" "),
            _c("hr"),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { key: "formatacaoSubFilter" },
          [
            _c("contabil-balancete-filtro-formatacao", {
              attrs: {
                button: "primary",
                colorSelected: _vm.colorSelected,
                colorDeselected: _vm.colorDeselected,
              },
              on: {
                "clear-perfil": function ($event) {
                  return _vm.emitClearPerfil()
                },
                "selecionar-perfil": _vm.emitSelecionarPerfil,
                "persistir-perfil": _vm.emitPersistirPerfil,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }